import dayjs, {Dayjs} from "dayjs";
import TicketType from "./TicketType";
import TicketStatusEnum from "../enums/TicketStatusEnum";

export default class Ticket {
    public id: string
    public displayId: number
    public title: string
    public author: string
    public content: string
    public file?: string
    public createdAt: Dayjs
    public updatedAt: Dayjs
    public treatedAt?: Dayjs
    public type?: TicketType
    public owner?: boolean
    public comment?: string
    public sender?: string
    public community?: string
    public treater?: string
    public status: TicketStatusEnum

    constructor(data: any) {
        this.id = data.reference || data.id
        this.displayId = data.id
        this.title = data.title
        this.content = data.content
        this.file = data.file
        this.owner = data.owner
        this.author = data.name
        if(data.comment)
            this.comment = data.comment
        if(data.sender)
            this.sender = data.sender
        if(data.community)
            this.community = data.community
        if(data.treater)
            this.treater = data.treater
        this.status = TicketStatusEnum.tryParse(data.status)
        this.type = new TicketType(data.ticketType)
        this.createdAt = dayjs(data.createdAt)
        this.updatedAt = dayjs(data.updatedAt)
        if(data.treatedAt)
            this.treatedAt = dayjs(data.treatedAt)
    }

    getStatusMap = () => {
        switch (this.status) {
            case TicketStatusEnum.pending:
                return { color: 'warning' }
            case TicketStatusEnum.treated:
                return { color: 'primary' }
            case TicketStatusEnum.cancelled:
                return { color: 'danger' }
            default:
                return { color: 'danger' }
        }
    }
}
